<template>
  <ElDialog
    name="select-default-payment-method-modal"
    v-loading="loading"
    :title="$t('companySettings.billing.paymentMethods.switchDefault.title')"
    v-on="$listeners"
    :visible="show"
    append-to-body
  >
    <div>
      <VForm :onSubmit="switchDefault" data-vv-scope="order" ref="form">
        <div slot="row">
          {{ $t('companySettings.billing.paymentMethods.switchDefault.message') }}
        </div>
        <div slot="formButtons">
          <VButton
            type="success"
            class="float-right"
            subtype="submit"
            href="#"
            data-ec="billing_set_default_payment_method_modal"
            data-et="yes_button">
            <CheckIcon />
            <span>{{ $t('functional.yes') }}</span>
          </VButton>
        </div>
      </VForm>
    </div>
  </ElDialog>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import { CheckIcon } from '@/components/icons/fontIcons';

export default {
  name: 'SelectDefaultPaymentMethodModal',
  components: {
    VButton,
    VForm,
    CheckIcon,
  },
  props: {
    show: Boolean,
    paymentMethodId: String,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async switchDefault() {
      if (this.paymentMethodId) {
        this.loading = true;
        await this.$store.dispatch('paymentMethods/SWITCH_DEFAULT_METHOD', { id: this.paymentMethodId });
        await this.$store.dispatch('paymentMethods/GET');
        this.$emit('close');
        this.loading = false;
      }
    },
  },
};
</script>
